import { h, render } from 'preact';
import { setup } from 'goober';
import { ConfigProvider } from './providers/ConfigProvider';
import { UnifiedWidgetProvider } from './providers/UnifiedWidgetProvider';
import { UnifiedWidget } from './UnifiedWidget';
import * as goober from 'goober';

setup(h);

const App = ({ gooberCss }: { gooberCss: typeof goober.css }) => {
  return (
    <ConfigProvider>
      <UnifiedWidgetProvider gooberCss={gooberCss}>
        <UnifiedWidget />
      </UnifiedWidgetProvider>
    </ConfigProvider>
  );
};

const initWidget = () => {
  if (document.getElementById("sa-unified-widget")) return;
  const root = document.createElement("div");
  root.id = "sa-unified-widget";
  const shadowRoot = root.attachShadow({ mode: "open" });
  document.body.appendChild(root);
  const gooberCss = goober.css.bind({ target: shadowRoot });
  render(<App gooberCss={gooberCss} />, shadowRoot);
};

// Global API
if (typeof window !== 'undefined') {
  window.SAWidget = window.SAWidget || {
    init: (config: any) => {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
          window.SAWidgetConfig = config;
          initWidget();
        });
      } else {
        window.SAWidgetConfig = config;
        initWidget();
      }
    },
    remove: () => {
      window.SAWidget.clearState?.();
      const root = document.getElementById("sa-unified-widget");
      if (root?.shadowRoot) render(null, root.shadowRoot);
      root?.remove();
    },
    reset: () => {
      window.SAWidget.remove();
      initWidget();
    },
  };

  // Auto-initialize if config is already available
  const existingConfig = (window as any).SAWidgetConfig;
  if (existingConfig) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initWidget);
    } else {
      initWidget();
    }
  }
}
